import { render, staticRenderFns } from "./report-data.vue?vue&type=template&id=06ec30f6&"
import script from "./report-data.ts?vue&type=script&lang=ts&"
export * from "./report-data.ts?vue&type=script&lang=ts&"
import style0 from "./report-data.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports